import React, { useEffect, useState } from 'react';
import { applyUpdate } from './applyUpdate';
import { hasPendingWrites, isBusy, onBusyChange, startFormTracking } from './busy';

const styles = {
  toast: {
    position: 'fixed',
    left: '50%',
    bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
    transform: 'translateX(-50%)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    maxWidth: 'calc(100vw - 32px)',
    padding: '10px 12px 10px 16px',
    borderRadius: 12,
    background: '#1f2937',
    color: '#fff',
    fontSize: 14,
    boxShadow: '0 8px 24px rgba(0,0,0,.25)',
  },
  button: {
    border: 0,
    borderRadius: 8,
    padding: '8px 14px',
    background: '#fff',
    color: '#1f2937',
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
};

/**
 * Atualização do app instalado, sem reinstalar:
 *  1. a nova versão é baixada em segundo plano, inteira (nunca versões misturadas);
 *  2. a troca acontece sozinha quando o app vai para segundo plano sem operação em andamento,
 *     ou quando o usuário toca em "Atualizar".
 *
 * @param {boolean} needRefresh há versão nova aguardando ativação
 * @param {() => (Promise|void)} [activate] ativação específica do app
 */
export default function UpdateToast({ needRefresh, activate }) {
  const [busy, setBusy] = useState(isBusy());
  const [applying, setApplying] = useState(false);

  useEffect(() => {
    startFormTracking();
    return onBusyChange(setBusy);
  }, []);

  useEffect(() => {
    if (!needRefresh) return undefined;
    const applyWhenHidden = () => {
      if (document.visibilityState === 'hidden' && !isBusy()) applyUpdate(activate);
    };
    document.addEventListener('visibilitychange', applyWhenHidden);
    return () => document.removeEventListener('visibilitychange', applyWhenHidden);
  }, [needRefresh, activate]);

  if (!needRefresh) return null;

  const onClick = () => {
    if (hasPendingWrites()) return;
    // eslint-disable-next-line no-alert
    if (isBusy() && !window.confirm('Há dados não salvos nesta tela. Atualizar agora e descartá-los?')) return;
    setApplying(true);
    applyUpdate(activate);
  };

  return (
    <div style={styles.toast} role="status">
      <span>Nova versão disponível.</span>
      <button type="button" style={styles.button} disabled={applying || hasPendingWrites()} onClick={onClick}>
        {applying ? 'Atualizando…' : busy ? 'Atualizar (dados não salvos)' : 'Atualizar'}
      </button>
    </div>
  );
}
